import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const BEFORE = ['Ves una Clase II y dudas cuál es su verdadero origen.', 'Eliges el aparato porque “es el que siempre funciona”.', 'Cada paciente representa un nuevo reto.', 'Explicas el tratamiento con inseguridad.', 'Temes equivocarte en la indicación.', 'Esperas que el aparato funcione.'];
const AFTER = ['Identificas si el problema es funcional, dentario o esquelético antes de pensar en un aparato.', 'Tomas la decisión basándote en un sistema clínico estructurado.', 'Todos los casos siguen una misma ruta diagnóstica.', 'Justificas cada decisión con criterio y seguridad profesional.', 'Tomas decisiones con mayor confianza y respaldo clínico.', 'Comprendes por qué funcionará antes de indicarlo.'];
export function BeforeAfter() {
  return <section className="w-full bg-white px-5 py-14 sm:px-6 sm:py-20" data-id="element-31" data-mp="30q73cg96upu5">
      <div className="mx-auto w-full max-w-4xl" data-id="element-32" data-mp="30pdrx1zabc5o">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-ofm-900 sm:text-4xl" data-id="element-33" data-mp="x40v6a886m5g">
          Lo que cambia cuando dejas de improvisar
        </h2>

        <div className="mt-9 grid gap-5 md:grid-cols-2" data-id="element-34" data-mp="172q1r6uo8k6e">
          <div className="rounded-2xl border border-[#E7C9C4] bg-[#FDF5F4] p-5 sm:p-6" data-id="element-35" data-mp="172801up8pdr3">
            <h3 className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-[0.12em] text-[#B3372A]" data-id="element-36" data-mp="124ybeh9od64b">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="eec3cpzo7lub" /> Antes
            </h3>
            <ul className="mt-4 space-y-3.5" data-id="element-38" data-mp="9gkds2mi0bta">
              {BEFORE.map(item => <li key={item} className="flex gap-2.5" data-id="element-39" data-mp="o4x9cyhobsn9">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#B3372A]" aria-hidden="true" data-id="element-40" data-mp="jd5kqti2vwzr" />
                  <span className="text-[14px] leading-snug text-ofm-900/75" data-id="element-41" data-mp="3rre4dc2mhdfs">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-ofm-200 bg-ofm-50 p-5 sm:p-6" data-id="element-42" data-mp="1qq7w7i5k79xg">
            <h3 className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-[0.12em] text-ofm-700" data-id="element-43" data-mp="1vosnut6qwlaa">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="20h2j8oqmqdjy" /> Con el Sistema OFM
            </h3>
            <ul className="mt-4 space-y-3.5" data-id="element-45" data-mp="24hmd9jfwp11v">
              {AFTER.map(item => <li key={item} className="flex gap-2.5" data-id="element-46" data-mp="17t6o3ogpktpa">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ofm-600" aria-hidden="true" data-id="element-47" data-mp="1cqonoo8u5wkm" />
                  <span className="text-[14px] font-medium leading-snug text-ofm-900/85" data-id="element-48" data-mp="1gr8ktrtet06r">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl" data-id="element-49" data-mp="2sa2whxbdqz2r">
          <CTAButton label="🦷 QUIERO PASAR A LA COLUMNA VERDE" subline="Sistema completo + 5 bonos por $12.99 USD" data-id="element-50" data-mp="2x5rys8esau2r" />
        </div>
      </div>
    </section>;
}